import React from 'react'

import type { WCDRouteProps } from '..'
import { Page } from '../components/Page'

export const freeAccountRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: '/free-account-unlocked',
    component: () => (
      <Page pagePath="article-listing/free-account-listing/FreeAccountListingPage" />
    ),
  },
  // dev
  {
    live: true,
    exact: true,
    path: [
      '/news/article/my-dog-ate-the-post-again-hmrc-reveals-the-decades-worst-excuses-for-late-tax-returns-a7bAg9f5rQUE',
    ],
    component: () => <Page context="news" pagePath="article/NewsArticlePage" />,
  },
  // prod
  {
    live: true,
    exact: true,
    path: [
      '/news/article/the-most-common-bloatware-we-found-on-laptops-aGeJX9U0NgXa',
      '/news/article/how-to-know-when-its-time-to-replace-the-battery-on-your-phone-a1GN25n5JWDV',
      '/news/article/the-most-important-tech-of-the-21st-century-aBe0I1b9dWbL',
      '/news/article/are-ray-ban-meta-smart-glasses-worth-it-aSfxq9j3vg7D',
      '/news/article/great-value-laundry-appliances-and-detergent-auIwj0x4dcWu',
      '/news/article/is-it-worth-buying-a-cheap-washer-dryer-akJEA4S79cQe',
      '/news/article/tips-for-washing-gym-clothes-amQXH2R0mcbw',
      '/news/article/eco-vs-quick-wash-which-dishwasher-program-is-cheapest-and-best-akubJ2t3A6gi',
      '/news/article/5-things-id-never-do-as-a-bathrooms-expert-atr1K5B0pua1',
      '/news/article/where-can-you-buy-jellycats-avu4l4t6GFgM',
      '/news/article/how-to-clean-your-toilet-aLLlH2a6VkTw',
      '/news/article/how-to-get-rid-of-scabies-the-best-way-to-clean-your-home-to-stop-scabies-aEkqB8N2zNMQ',
      '/news/article/plug-sockets-how-to-avoid-overloading-your-plug-sockets-at-home-aqE1R8P7pK59',
      '/news/article/7-things-you-should-know-before-acting-as-an-executor-ac4Ia0y95RFR',
      '/news/article/potholes-can-wreck-your-car-and-your-insurance-a5MVX5b7VqWH',
      '/news/article/cheap-and-free-things-to-do-with-the-kids-during-the-school-holidays-aVHnf5U4tOg7',
      '/news/article/should-you-open-a-joint-savings-account-ap8nD7J9OURo',
      '/news/article/has-my-pet-insurance-become-pointless-anlr35U9c5sR',
      '/news/article/9-tips-to-save-money-this-valentines-day-a9O7i5g4td1d',
      '/news/article/uk-bank-holidays-ap3wT8p13R58',
      '/news/article/eurostar-snap-aKNLm0I41TG1',
      '/news/article/how-much-do-you-need-to-spend-on-a-pushchair-aYC5Z4t0HXL9',
      '/news/article/revealed-the-uks-most-and-least-loved-cars-auZ1P2p9cqrG',
    ],
    component: () => <Page context="news" pagePath="article/NewsArticlePage" />,
  },
  {
    live: true,
    exact: true,
    path: [
      '/reviews/best-and-worst-shops/article/best-and-worst-shops/best-technology-shops-aSZ976V7o0EA',
      '/reviews/best-and-worst-shops/article/best-and-worst-shops/best-and-worst-baby-shops-aVPr72O99OPv',
      '/reviews/best-and-worst-shops/article/best-and-worst-shops/best-home-and-diy-shops-auwlu0o139xJ',
      '/reviews/energy-companies/article/energy-company-reviews/100green-ai2k24n4hnaQ',
      '/reviews/energy-companies/article/energy-company-reviews/british-gas-axmgQ2T0WL5v',
      '/reviews/energy-companies/article/energy-company-reviews/co-op-energy-azuC13f02VKs',
      '/reviews/energy-companies/article/energy-company-reviews/e-a1JqL5R762VL',
      '/reviews/energy-companies/article/energy-company-reviews/e.on-next-asTGf4U1ggxU',
      '/reviews/energy-companies/article/energy-company-reviews/edf-energy-aKUVQ8T9pWpP',
      '/reviews/energy-companies/article/energy-company-reviews/ecotricity-aeVNT3V4JeDq',
      '/reviews/energy-companies/article/energy-company-reviews/fuse-energy-apE5X7t3MFKS',
      '/reviews/energy-companies/article/energy-company-reviews/good-energy-aimFJ0H8iW6w',
      '/reviews/energy-companies/article/energy-company-reviews/octopus-energy-aESDM2a8ISWP',
      '/reviews/energy-companies/article/energy-company-reviews/outfox-energy-aqenZ9i9wL7W',
      '/reviews/energy-companies/article/energy-company-reviews/ovo-energy-aSJ3S9I4v5Ji',
      '/reviews/energy-companies/article/energy-company-reviews/sainsburys-energy-aygAa2D4TusV',
      '/reviews/energy-companies/article/energy-company-reviews/scottish-power-aaZBx4v6vv5N',
      '/reviews/energy-companies/article/energy-company-reviews/so-energy-a8dUQ1E4De5y',
      '/reviews/energy-companies/article/energy-company-reviews/utilita-albUp1H2SQ5H',
      '/reviews/energy-companies/article/energy-company-reviews/utility-warehouse-arMyL2D8l4qv',
      '/reviews/energy-companies/article/energy-companies/which-energy-survey-results-ajqM43e6ycY8',
      '/reviews/energy-companies/article/best-and-worst-energy-companies/energy-companies-which-recommended-providers-adf5i8r3xh3v',
      '/reviews/energy-companies/article/best-and-worst-energy-companies/how-to-choose-the-best-energy-company-aOpXt2w0re4F',
    ],
    component: () => <Page pagePath="article/ReviewsAdviceMultiPage" context="reviews" />,
  },
  {
    live: true,
    exact: true,
    path: [
      '/reviews/supermarkets/article/best-supermarkets-aOJjN2J0A10N',
      '/reviews/energy-companies/article/northern-ireland-electricity-and-gas-aPKA91X5l7Di',
    ],
    component: () => <Page pagePath="article/ReviewsAdviceSinglePage" context="reviews" />,
  },
  {
    live: true,
    exact: true,
    path: [
      '/money/tax/income-tax/tax-rates-and-allowances/income-tax-calculator-aNIhq2U0bUxs',
      '/money/savings-and-isas/isas/cash-isas/how-to-find-the-best-cash-isa-aFVYt5p36yPe',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-credit-card-deals-azBc81J579Kj',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-air-mile-credit-cards-agQDg6V9kH49',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-cash-back-credit-cards-akfnR0Q4GK6X',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-travel-credit-cards-aHLGN5d6y8JR',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-interest-free-credit-cards-aKZ701r6uXXP',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-0-balance-transfer-credit-cards-atMFj4R64A0D',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-0-money-transfer-credit-cards-aNztC3n06PZb',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-low-interest-credit-cards-aK63v2V1RvgN',
      '/money/credit-cards-and-loans/credit-cards/best-credit-card-deals/best-credit-cards-for-bad-credit-aHmL05R6AJtK',
      '/money/credit-cards-and-loans/credit-cards/credit-card-companies/best-credit-card-providers-aztfP3Z69rfU',
    ],
    component: () => <Page pagePath="article/ReviewsAdviceMultiPage" context="money" />,
  },
  {
    live: true,
    exact: true,
    path: [
      '/money/tax/council-tax/council-tax-calculator-a5K856P7KFqD',
      '/money/tax/tax-calculators/child-benefit-calculator-aZ6aX1Q6byzJ',
      '/money/tax/tax-credits-and-benefits/child-benefit-ajRMh2r8Efbr',
      '/money/tax/income-tax/income-tax-on-savings-and-investments/dividend-tax-calculator-aNE2C9l1i9qq',
      '/money/tax/tax-calculators/national-insurance-calculator-aGMzN8b8QI6N',
    ],
    component: () => <Page pagePath="article/ReviewsAdviceSinglePage" context="money" />,
  },
]
